import { ThemeConfig } from 'antd';
import Cookies from 'js-cookie';

const Theme: ThemeConfig = {
  token: {
    borderRadius: 4,
    colorPrimary: '#eb0045',
    colorLink: '#eb0045',
    colorPrimaryHover: '#C9013C',
    colorPrimaryActive: '#C9013C',
    colorPrimaryBg: '#FDE6ED',
    colorPrimaryBgHover: '#FDE6ED',
  },
};

// 缓存主题 token 到 cookies
export const cacheThemeToken = () => {
  try {
    const domainParts = window.location.hostname.split('.');
    const mainDomain =
      domainParts.length > 1 ? domainParts.slice(-2).join('.') : window.location.hostname;
    Cookies.set('themeToken', JSON.stringify(Theme.token), { domain: mainDomain });
  } catch (error) {
    console.error('缓存主题token失败:', error);
  }
};

// 缓存 token 到 cookies, 用于跨域站点
export const cacheSameSiteToken = () => {
  const domainParts = window.location.hostname.split('.');
  const mainDomain =
    domainParts.length > 1 ? domainParts.slice(-2).join('.') : window.location.hostname;
  Cookies.set('token', Cookies.get('token') || '', { domain: mainDomain });
};

export const setTheme = () => {
  const {
    colorPrimary,
    colorPrimaryHover,
    colorPrimaryActive,
    colorPrimaryBg,
    colorPrimaryBgHover,
  } = Theme.token as any;
  const vars = {
    '--primary-color': colorPrimary,
    '--primary-color-hover': colorPrimaryHover,
    '--primary-color-active': colorPrimaryActive,
    '--primary-bg-color': colorPrimaryBg,
    '--primary-bg-color-hover': colorPrimaryBgHover,
    '--transparent': 'transparent',
  };

  Object.entries(vars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value as string);
  });
};

export default Theme;
